import { useResourceOne } from "@/hooks/useResourceOne";
import { useResourceUpdate } from "@/hooks/useResourceUpdate";

export const usePoolCapacityConfig = (id) => {
  const { mutateAsync, isLoading: isSaving } = useResourceUpdate();
  
  const { data, isLoading, isError } = useResourceOne({
    skip: !id,
    meta: {
      op: 'capacity',
    },
  });
  return {
    isLoading,
    isSaving,
    save: async (data) => {
      return await mutateAsync({ values: data });
    },
    value: (isLoading || isError) ? {} : { capacity: data?.capacity, name: data?.name },
    schema: [
      {
        i18nTitle: ("config.pool.form.name"),
        title: "Name",
        dataIndex: "name",
        valueType: "text",
        width: "md",
      },
      {
        i18nTitle: "config.pool.form.capacity",
        title: "Capacity",
        dataIndex: "capacity",
        valueType: "digit",
        width: "md",
      },
    ],
  };
};